import React from 'react'
import TransferAccounts from './TransferAccounts'
import { withGlobal } from 'components/global/GlobalWrapper'
import { propertyTransferReducers } from 'components/stores/property_transfer/reducers'

export default withGlobal(TransferAccounts, {
  reducers: propertyTransferReducers,
})
